import type React from 'react'
import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {BuildWidget} from '../Widgets/BuildWidget/index'
import {DeployWidget} from '../Widgets/DeployWidget/index'
import {RepoWidget} from '../Widgets/RepoWidget/index'
import {AppSecWidget} from '../Widgets/AppSecWidget/index'
import {QAMetricsWidget} from '../Widgets/QAMetricsWidget/index'
import {FeatureWidget} from '../Widgets/FeatureWidget/index'
import {SecurityWidget} from '../Widgets/SecurityWidget'
import AccordionWrapper from '../../../GDS/molecules/AccordionWrapper/AccordionWrapper'
import ButtonWrapper from '../../../GDS/molecules/Button/Button'
import sharedStyles from '@/components/SelfOnboarding/Shared/OnboardingFormShared.module.css'
import type {RootState} from '@/store'

interface TeamStepTwoProps {
  values: any
  errors: any
  touched: any
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  setWidgetConfigErrors?: (errors: any) => void
}

const TeamStepTwo: React.FC<TeamStepTwoProps> = ({setWidgetConfigErrors}) => {
  const dispatch = useDispatch()
  const [buildError, setBuildError] = useState(false)
  const [deployError, setDeployError] = useState(false)
  const [repoError, setRepoError] = useState(false)
  const [appsecError, setAppsecError] = useState(false)
  const [securityError, setSecurityError] = useState(false)
  const [qaError, setQaError] = useState(false)
  const [featureError, setFeatureError] = useState(false)

  // Aggregate widget errors and report to parent
  useEffect(() => {
    const errors: any = {}
    if (buildError) errors.build = true
    if (deployError) errors.deploy = true
    if (repoError) errors.repo = true
    if (appsecError) errors.appsec = true
    if (securityError) errors.security = true
    if (qaError) errors.qa = true
    if (featureError) errors.feature = true
    setWidgetConfigErrors?.(errors)
  }, [buildError, deployError, repoError, appsecError, securityError, qaError, featureError, setWidgetConfigErrors])
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null)
  const isDark = useSelector((state: RootState) => state.theme.mode === 'dark')

  const handleExpand = (idx: number) => {
    setExpandedIdx(expandedIdx === idx ? null : idx)
  }

  return (
    <div className={sharedStyles.selfOnboardingWrapper}>
      <AccordionWrapper
        presentation="no-background"
        separator={true}
        items={[
          {
            label: 'Build',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <ButtonWrapper
                  iconTrailing={'add_circle_outline'}
                  variant="tertiary"
                  size="small"
                  text={'Add Section'}
                  onClick={() => handleExpand(1)}
                />
              </div>
            ),
            children: <BuildWidget onValidationChange={setBuildError} />,
          },
          {
            label: 'Deploy',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(2)}
              />
            ),
            children: <DeployWidget onValidationChange={setDeployError} />,
          },
          {
            label: 'Code Repo',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(3)}
              />
            ),
            children: <RepoWidget onValidationChange={setRepoError} />,
          },
          {
            label: 'Security Analysis',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(4)}
              />
            ),
            children: <AppSecWidget onValidationChange={setAppsecError} />,
          },
          {
            label: 'Code Analysis',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(5)}
              />
            ),
            children: <SecurityWidget onValidationChange={setSecurityError} />,
          },
          {
            label: 'QA Metrics',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(6)}
              />
            ),
            children: <QAMetricsWidget onValidationChange={setQaError} />,
          },
          {
            label: 'Features',
            presentation: 'box-shadow',
            rightAccessoryChild: (
              <ButtonWrapper
                iconTrailing={'add_circle_outline'}
                variant="tertiary"
                size="small"
                text={'Add Section'}
                onClick={() => handleExpand(7)}
              />
            ),
            children: <FeatureWidget onValidationChange={setFeatureError} />,
          },
        ]}
      />
    </div>
  )
}

export default TeamStepTwo
